<template>
  <div>

<v-snackbar dark v-model="snackbar" :timeout="4000" top>
      <span>You just added a new solution concept.</span>
      <v-btn flat color="primary" @click="snackbar = false">Close</v-btn>
    </v-snackbar>


    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title> 
                 <v-layout row wrap align-center justify-center class="mt-2">
              <span class="headline font-weight-bold">Creating Ecosystems with new product offerings</span> 

              <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify mt-3"
                outline>
                <span>Tip: Based on your solution concept which has been designed until this point, is there any parallel solution concept(s) which you can think of which would provide value to the customer?
                    <br/>
                    One example of this is Uber Eats which was derived from the Original Uber solution. Another example is the Apple watch which was designed as a complementary offering to the iPhone/iPad line of products.
                </span>
              </v-alert>
                 </v-layout>
            </v-card-title>
            <v-card-text>

                

              <v-form class="px-1" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->
                   
                <!-- <v-spacer></v-spacer> -->

 <v-container grid-list-md>

                  <v-layout align-center justify-center v-for="(parallelsolutionconcept,index) in parallelsolutionconcepts" :key="index">


    <v-flex wrap>
      <v-hover >
 

              <v-card
    class="rounded-card mx-auto"  
    color="#F7C3B1"
    max-width="800"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"    
  >
    <v-card-title>
      <!-- <v-icon
        large
        left
      >
        card_giftcard
      </v-icon> -->
      <span class="title font-weight-light"> <b>{{parallelsolutionconcept.solutionname}} </b>  </span> 
      <!-- Solution: My ToDo (Solution Offering) -->
    </v-card-title>

   <v-card-text class="subtitle-1 font-weight-light">
      {{parallelsolutionconcept.solutiondescription}}
    </v-card-text> 

    <!-- <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
           <v-btn to="/bifdashboard" flat color="primary">View Wireframe</v-btn> 
        </v-layout>
      </v-list-tile>
    </v-card-actions> -->
    <v-card-actions>
      
            <v-layout 
              justify-end
            >
            <!-- <v-btn to="/bifdashboard" flat icon>
                <v-icon>edit</v-icon>
              </v-btn> 
              <v-btn to="/bifdashboard" flat icon>
                <v-icon>delete</v-icon>
              </v-btn>  -->
              <v-btn flat icon>
                <v-icon>edit</v-icon>
              </v-btn> 
              <v-btn flat icon>
                <v-icon>delete</v-icon>
              </v-btn> 
            </v-layout>
    </v-card-actions> 
  </v-card>
        </v-hover>
    </v-flex>

  </v-layout>

 </v-container>

 <Popupaddparallelinnovations @quoteconfirmed="snackbar = true" />
<!-- <v-btn class="mx-2" disabled flat fab>
        <v-icon dark>add</v-icon>
        </v-btn> -->

                <v-spacer></v-spacer>
                
                <v-btn flat @click="$router.go(-1)" class="mx-4">Head back</v-btn>
                 <!-- <v-btn flat @click="submit" color="primary" class="mx-2 mt-3">Head to Metrics</v-btn> -->  
                 <!-- <Popupcongratsbif /> -->
                <v-btn flat to="/bcprocessmodelstep10" color="primary" class="mx-2 mt-3"><!--Head to Metrics--> Complete Step 9</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import Popupaddparallelinnovations from '../components/Popupaddparallelinnovations'
//import Popupcongratsbif from '../components/Popupcongratsbif'
import gvars from '../globalvariables'

export default {
  name: "addparallelinnovations",
  components: {
   // Popupcongratsbif,
    Popupaddparallelinnovations
  },
  data() {
    return { 
      doWe: false,
      projecttitle:'My Venture v22',
      projecttitleEnabled: false,
      projecttitleLabelText: 'Provide a title for your project',
      customerproblemdescription:'Description Blah Blah Blah Blah', 
      customerproblemdescriptionEnabled: false,
      customerproblemdescriptionLabelText: 'Describe the problem that the customer is facing',
      whythisproblem: 'Why Blah Blah Blah Blah',
      whythisproblemEnabled: false,
      whythisproblemLabelText: 'Why is the problem important to the customer?',
      targetagerange: 'between 18 and 60 years',
      targetagerangeEnabled: false,
      targetagerangeLabelText: 'What is the age range of the target audience?',
      problemdomain: 'Not Sure',      
      problemdomainEnabled: false,
      problemdomainLabelText: 'Which domain does this Problem fall in?',
      additionaldetailforproblem: 'Additional detail Blah Blah Blah Blah',
      additionaldetailforproblemEnabled: false,
      additionaldetailforproblemLabelText: 'Is there any other detail you would like to add?',
      dropdownList: [
        {component: 'projecttitle', isEnabled: false, titleText: 'Provide a title for your project'},
        {component: 'customerproblemdescription', isEnabled: false, titleText: 'Describe the problem that the customer is facing'},
        {component: 'whythisproblem', isEnabled: false, titleText: 'Why is the problem important to the customer?'},
        {component: 'targetagerange', isEnabled: false, titleText: 'What is the age range of the target audience?'},
        {component: 'problemdomain', isEnabled: false, titleText: 'Which domain does this Problem fall in?'},
        {component: 'additionaldetailforproblem', isEnabled: false, titleText: 'Is there any other detail you would like to add?'}
      ],
      customerproblemdetails: [
        { title: 'Add Project Title', storagecode: 'projecttitle', labeltext: 'Provide a title for your project', type: 'title', textValue: 'My Venture v2', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Details of the customer problem', storagecode: 'customerproblemdescription', labeltext: 'Describe the problem that the customer is facing', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Importance of the problem to the customer', storagecode: 'whythisproblem', labeltext: 'Why is the problem important to the customer?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'folder', componentid: false, tooltip: false },
        { title: 'Add Age range', storagecode: 'targetagerange', labeltext: 'What is the age range of the target audience?', type: 'agerange', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add the problem domain', storagecode: 'problemdomain', labeltext: 'Which domain does this Problem fall in?', type: 'select', textValue: 'Not Sure', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add additional misc. details', storagecode: 'additionaldetailforproblem', labeltext: 'Is there any other detail you would like to add?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: false, tooltip: true }
      ],
      parallelsolutionconcepts: [],
      quotes: [],
      slider: 45,
        volume: 10,
        age: [18, 60],
      items: ['Enterprise', 'Consumer', 'Both Enterprise and Consumer', 'Not Sure'],
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      snackbar: false
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
//  if(this.$refs.form.validate()) {
//         console.log("Attempt to submit")
//         const project = {

//           projecttitle: this.projecttitle,
//           customerproblemdescription: this.customerproblemdescription,
//           whythisproblem: this.whythisproblem,
//           targetagerange: this.targetagerange,
//           problemdomain: this.problemdomain,
//           additionaldetailforproblem: this.additionaldetailforproblem
//         }

//       //   db.collection('projects').add(project).then(() => {
//       //     console.log("added to db!")
//       //   })
//       // }

//         db.collection('projects').add(project).then(function(docRef) {
//                 console.log("Document written with ID: ", docRef.id);
//             })
//             .catch(function(error) {
//                 console.error("Error adding document: ", error);
//             });
//         }

      this.$router.push('dumaddmetricsbif')

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    remainingDetailsToBeAdded(){
      return this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
    }
  },
  created(){
    db.collection('projects').doc(this.getProjectID()).collection('parallelsolutionconcepts').onSnapshot(res => {

      const changes = res.docChanges();

      changes.forEach(change => {
        if (change.type === 'added'){
          this.parallelsolutionconcepts.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      }) 

    })
    //console.log(this.solutionconcepts)
  }
};
</script>

<style>
.rounded-card{
  border-radius:10px;
}
</style>
